import { useState } from "react";
import "./DeletePainAssessmentModal.css";

import { useAppContext } from "../../../../classes/contexts/AppContext";
import { useNotification } from "../../../../classes/contexts/NotificationContext";
import IconsEnum from "../../../../classes/enums/IconsEnum";
import { SnackbarType } from "../../../../classes/enums/SnackbarTypeEnum";
import Button from "../../../../components/button/Button";
import WarningIcon from "../../../../components/icons/WarningIcon";
import IconButton from "../../../../components/iconButton/IconButton";
import useTranslation from "../../../../hooks/i18n/useTranslation";
import { deletePainAssessment } from "../../../../services/PainAssessmentService";

const DeletePainAssessmentModal = ({ assessment, onAssessmentDeleted }) => {
  const [isDeleting, setIsDeleting] = useState(false);
  const { t } = useTranslation();
  const { hidePopup } = useAppContext();
  const { addNotification } = useNotification();

  const handleConfirm = async () => {
    if (isDeleting) return;
    setIsDeleting(true);
    try {
      await deletePainAssessment(assessment._id);
      if (onAssessmentDeleted) {
        await onAssessmentDeleted();
      }
      hidePopup();
    } catch (error) {
      addNotification(SnackbarType.ERROR, error.message);
      setIsDeleting(false);
    }
  };

  const handleClose = () => {
    if (!isDeleting) hidePopup();
  };

  return (
    <div className="App-module-delete-pain-assessment-modal-container">
      <div className="App-module-delete-pain-assessment-modal-close">
        <IconButton
          icon={IconsEnum.CLOSE}
          onClick={handleClose}
          noBgColor={true}
          disabled={isDeleting}
          title={t("43")}
        />
      </div>
      <div className="App-module-delete-pain-assessment-modal-header">
        <WarningIcon />
        <h2>Delete Pain Assessment</h2>
      </div>
      <div className="App-module-delete-pain-assessment-modal-body">
        <p className="confirmation-question">
          Are you sure you want to delete this pain assessment?
        </p>
      </div>
      <div className="App-module-delete-pain-assessment-modal-actions">
        <Button
          value={t("4")}
          disabled={isDeleting}
          onClick={handleConfirm}
          className="delete-button"
        />
      </div>
    </div>
  );
};

export default DeletePainAssessmentModal;
